import { QuestionBase } from './question-base';

export class ReadOnlyTextareaQuestion extends QuestionBase<string> {
  controlType = 'read-only-textarea';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}
